import { CircularProgress, SxProps, Theme, styled } from '@mui/material'
import { CSSProperties, forwardRef } from 'react'

export type LoadingSize = 'small' | 'medium' | 'large'
const loadingSizes: Record<LoadingSize, number> = {
  small: 18,
  medium: 45,
  large: 60,
}

export interface LoadingIndicatorProps {
  size?: LoadingSize | number
  style?: CSSProperties
  sx?: SxProps<Theme>
}

const LoadingIndicator = forwardRef<HTMLDivElement, LoadingIndicatorProps>(
  ({ size = 'medium', style, sx }, ref) => (
    <Container ref={ref} style={style} sx={sx}>
      <CircularProgress size={loadingSizes[size] ?? size} />
    </Container>
  )
)

const Container = styled('div')`
  width: 100%;
  height: 100%;
  min-width: 350px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2em;
`

export default LoadingIndicator
